export default __webpack_public_path__ + "static/media/Suspense-accounts.6b5d1d0c.svg";